import {
  DEFAULT_AUTOCOMPLETE_CLASS_NAME,
  CREDENTIAL_PROVIDER_AUTOCOMPLETE_CLASS_NAME,
  FORM_SELECT_AUTOCOMPLETE_CLASS_NAME,
} from '../../constants/autocomplete';

const defaultFingoAutocomplete = () => ({});

export const credentialProviderAutocomplete = ({ theme, mainColor }) => ({
  '& .MuiOutlinedInput-root': {
    padding: '16px 24px',
    backgroundColor: theme.palette.gray.A100,
  },
  '& .MuiOutlinedInput-input': {
    backgroundColor: theme.palette.gray.A100,
    fontSize: theme.typography.medium_1.fontSize,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.small_2.fontSize,
    },
    color: theme.palette.gray.A500,
    '&::placeholder': {
      opacity: 1,
    },
  },
  '& .MuiAutocomplete-popupIndicator': {
    color: mainColor,
  },
  '& .MuiAutocomplete-inputRoot': {
    border: `2px solid ${theme.palette.gray.A300}`,
    backgroundColor: theme.palette.gray.A100,
    borderRadius: '16px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
      border: 'none',
    },
    '&:hover': {
      borderColor: mainColor,
    },
    '&.Mui-focused': {
      borderColor: mainColor,
    },
  },
  '& .MuiAutocomplete-listbox': {
    backgroundColor: '#fffbe6',
    borderRadius: 16,
    boxShadow: '0px 2px 8px rgba(0,0,0,0.08)',
  },
  '& .MuiAutocomplete-paper': {
    margin: '8px',
  },
});

export const formSelectAutocomplete = ({ theme, mainColor }) => ({
  '& .MuiOutlinedInput-root': {
    height: 50,
    minHeight: 46,
    borderRadius: 8,
    backgroundColor: '#fff',
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    paddingLeft: 0,
    paddingRight: theme.spacing(1),
    fontWeight: 500,
    fontSize: theme.typography.small_2.fontSize,
    lineHeight: '140%',
    '&:hover fieldset': {
      borderColor: theme.palette.gray.A400,
    },
    '&.Mui-focused fieldset': {
      borderColor: mainColor,
      borderWidth: 1,
    },
  },
  '& .MuiAutocomplete-input': {
    padding: '12px !important',
    fontWeight: 500,
    fontSize: theme.typography.small_2.fontSize,
    lineHeight: '140%',
    backgroundColor: 'transparent',
    '&::placeholder': {
      opacity: 1,
      color: theme.palette.gray.A500,
    },
  },
  '& .MuiAutocomplete-popupIndicator': {
    color: theme.palette.gray.A500,
    '& .MuiSvgIcon-root': {
      width: 28,
      height: 28,
    },
  },
  '& .MuiAutocomplete-clearIndicator': {
    color: theme.palette.gray.A500,
  },
});

const MuiAutocomplete = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DEFAULT_AUTOCOMPLETE_CLASS_NAME}`]: defaultFingoAutocomplete({ theme }),
      [`&.${CREDENTIAL_PROVIDER_AUTOCOMPLETE_CLASS_NAME}`]: credentialProviderAutocomplete({
        theme,
        mainColor: theme.palette.primary.main,
      }),
      [`&.${FORM_SELECT_AUTOCOMPLETE_CLASS_NAME}`]: formSelectAutocomplete({
        theme,
        mainColor: theme.palette.primary.main,
      }),
    }),
  },
};

export default MuiAutocomplete;
